import React from 'react';

import { MCButton, TextField, SelectField, ToggleSwitch, View, MCText } from 'src/components/basic';
import { popupModel } from 'src/components/complex';
import { BASE_ICONS } from 'src/components/svg';
import BaseComponent from 'src/components/BaseComponent';
import AlertManager from 'src/components/alert';
import ShortInfo from 'src/components/user/ShortInfo';

import Tooltip from 'src/components/basic/Tooltip';
import TOOLTIP_CONST from 'src/helpers/lang/tooltip';
import LANG_CONST from 'src/helpers/lang/const';
import { lang, permissions, remCss, withRouter } from 'src/helpers';
import constants from 'src/constants';

import model from './model';
import Add from './Add';

const followUpDurationOptions = [
  { value: 15, label: `15 ${lang.t('Days')}` },
  { value: 30, label: `30 ${lang.t('Days')}` },
  { value: 45, label: `45 ${lang.t('Days')}` },
  { value: 60, label: `60 ${lang.t('Days')}` },
  { value: 90, label: `90 ${lang.t('Days')}` },
  { value: 180, label: `6 ${lang.t('Months')}` },
  { value: 270, label: `9 ${lang.t('Months')}` },
  { value: 365, label: `12 ${lang.t('Months')}` }
];

const chatTicketDurationOptions = [
  { value: 1, label: `1 ${lang.t('Days')}` },
  { value: 2, label: `2 ${lang.t('Days')}` },
  { value: 3, label: `3 ${lang.t('Days')}` },
  { value: 4, label: `4 ${lang.t('Days')}` },
  { value: 5, label: `5 ${lang.t('Days')}` },
  { value: 7, label: `1 ${lang.t('Week')}` },
  { value: 14, label: `2 ${lang.t('Weeks')}` },
  { value: 21, label: `3 ${lang.t('Weeks')}` },
  { value: 30, label: `4 ${lang.t('Weeks')}` }
];

class ConsultationCharge extends BaseComponent {
  componentDidMount() {
    model.subscribe(this.subscription);
    if (model.state.user) model.onLoad();
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
  }

  getCurrency = () => {
    return model.input('currency');
  };

  saveCharges = (e) => {
    e.preventDefault();
    model.saveCharges(() => {
      const { invalid } = model.getApiState('charges');

      const errorAll = Object.values(invalid).find((e) => !!e['required_all']);

      if (errorAll && errorAll['required_all']) {
        AlertManager.popup(AlertManager.TYPES.WARN, {
          close: false,
          title: errorAll['required_all'],
          actionButton: {
            label: LANG_CONST.buttons.ok,
            action: ({ hide }) => hide()
          }
        });
      }
    });
  };
  removeCharge = (item) => {
    AlertManager.popup(AlertManager.TYPES.WARN, {
      close: false,
      title: LANG_CONST.notice.delete,
      cancelButton: {
        label: LANG_CONST.buttons.no,
        action: (actions) => actions.hide()
      },
      actionButton: {
        label: LANG_CONST.buttons.yes,
        action: (actions) => {
          actions.setLoading(true);
          model.removeCharge(item, () => {
            actions.hide();
            actions.setLoading(false);
          });
        }
      }
    });
  };
  cancelConsultation = (e) => {
    e.preventDefault();
    model.resetCharges();
  };

  renderChatTicket = (dataSet, name, title) => {
    const id = dataSet.id || 'default';
    const data = dataSet[name] || {};
    const { handleCharges } = model;
    const { invalid, loading } = model.getApiState('charges');
    let paid = !!data.paid;

    return (
      <div className={'mc-flex-20-col'} key={'form-group-' + id + '-' + name}>
        <div className={'mc-flex-20'}>
          <div className={'mc-value-518'}>{lang.t(title)}</div>
          <ToggleSwitch
            name='paid'
            checked={paid}
            onChange={() => handleCharges(id, name, 'paid')('paid', !paid)}
          />
        </div>
        {paid && (
          <>
            <div className={'mc-flex-20'}>
              <div className={'mc-grow'}>
                <TextField
                  template={3}
                  type={'money'}
                  currency={this.getCurrency()}
                  placeholder={LANG_CONST.not_set}
                  label={LANG_CONST.price}
                  name={'price'}
                  value={data['price']}
                  onChange={handleCharges(id, name, 'price')}
                  invalid={invalid[[id, name, 'price'].join('_')]}
                  disabled={loading}
                />
              </div>
              <div className={'mc-grow'}>
                <TextField
                  template={3}
                  type='select'
                  placeholder={LANG_CONST.not_set}
                  label={LANG_CONST.duration}
                  name={'duration'}
                  value={data['duration']}
                  onChange={handleCharges(id, name, 'duration')}
                  invalid={invalid[[id, name, 'duration'].join('_')]}
                  disabled={loading}
                  inputProps={{
                    minWidth: remCss(150),
                    options: chatTicketDurationOptions
                  }}
                />
              </div>
            </div>
            <div className={'mc-flex-20'}>
              <div className={'mc-grow'}>
                <TextField
                  type='number'
                  template={3}
                  placeholder={LANG_CONST.not_set}
                  label={LANG_CONST.no_of_message}
                  name={'messagesCount'}
                  value={data['messagesCount']}
                  onChange={handleCharges(id, name, 'messagesCount')}
                  invalid={invalid[[id, name, 'messagesCount'].join('_')]}
                  disabled={loading}
                />
              </div>
              <div className={'mc-grow'}>
                <TextField
                  template={3}
                  type={'money'}
                  currency={this.getCurrency()}
                  placeholder={LANG_CONST.not_set}
                  label={LANG_CONST.extra_message}
                  name={'extraMessage'}
                  value={data['extraMessage']}
                  onChange={handleCharges(id, name, 'extraMessage')}
                  invalid={invalid[[id, name, 'extraMessage'].join('_')]}
                  disabled={loading}
                />
              </div>
            </div>
          </>
        )}
      </div>
    );
  };

  renderPrices = (dataSet, name, title, tooltip) => {
    const id = dataSet.id || 'default';
    const data = dataSet[name] || {};
    const { handleCharges } = model;
    const { user } = model.state;
    const { invalid, loading } = model.getApiState('charges');

    return (
      <div className={'mc-flex-20-col'} key={'form-group-' + id + '-' + name}>
        <div className={'mc-flex-20'}>
          <div className={'mc-value-518'}>{lang.t(title)}</div>
          {tooltip && (
            <Tooltip markIcon={'?'} text={tooltip} layerProp={{ placement: 'right-center' }} />
          )}
        </div>
        <div className={'mc-flex-20'}>
          {[
            {
              n: 'virtual',
              l: 'Virtual',
              tooltip:
                id === 'default' && name === 'first'
                  ? user?.isDoctor
                    ? TOOLTIP_CONST.doctor_virtual_consultation
                    : TOOLTIP_CONST.clinic_virtual_consultation
                  : null
            },
            { n: 'office', l: 'Office' }
          ].map((option) => {
            const handelChange = handleCharges(id, name, option.n);

            const key = [id, name, option.n].join('_');
            return (
              <div className={'mc-grow'} key={key}>
                <TextField
                  template={3}
                  type={'money'}
                  currency={this.getCurrency()}
                  placeholder={LANG_CONST.not_set}
                  labelHtml={
                    <View style={{ flexDirection: 'row', gap: remCss(20), alignItems: 'center' }}>
                      {lang.t(option.l)}{' '}
                      {option.tooltip && (
                        <Tooltip
                          markIcon={'?'}
                          text={option.tooltip}
                          layerProp={{ placement: 'right-center' }}
                        />
                      )}
                    </View>
                  }
                  name={option.n}
                  value={data[option.n]}
                  onChange={handelChange}
                  invalid={invalid[key]}
                  disabled={loading}
                />
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  renderSet = (dataSet) => {
    const id = dataSet.id || 'default';

    const auth = model.state.user;

    const user = auth?.isClinic && (model.state.doctors || []).find((d) => d.id == id);
    const hospital =
      auth?.isDoctor && !auth?.createdBy && (model.state.hospitals || []).find((d) => d.id == id);
    let followUpDuration = model.input('followupDuration') || 30;

    return (
      <div className={'mc-flex-20-col'} key={id}>
        {user && (
          <div className={'mc-flex-20'}>
            <ShortInfo user={user} />
            <MCButton
              label={LANG_CONST.buttons.delete}
              iconname={BASE_ICONS.DELETE}
              secondary
              light
              radius
              onClick={() => this.removeCharge(dataSet)}
            />
          </div>
        )}
        {hospital && (
          <div className={'mc-flex-20'}>
            <div className={'mc-flex-5-col mc-grow'}>
              <div className={'mc-label-418'}>{lang.t(LANG_CONST.hospital_name)}</div>
              <div className={'mc-value-520'}>{hospital.hospital?.split('_')[0]}</div>
            </div>
            <MCButton
              label={LANG_CONST.buttons.delete}
              iconname={BASE_ICONS.DELETE}
              secondary
              light
              radius
              onClick={() => this.removeCharge(dataSet)}
            />
          </div>
        )}
        {this.renderPrices(
          dataSet,
          'first',
          LANG_CONST.first_consultation,
          id === 'default' &&
            (model.state.user?.isDoctor
              ? TOOLTIP_CONST.doctor_first_consultation
              : TOOLTIP_CONST.clinic_first_consultation)
        )}
        {this.renderPrices(
          dataSet,
          'followup',
          lang.t(LANG_CONST.text.follow_up, { attr: followUpDuration })
        )}
        {this.renderChatTicket(dataSet, 'chatTicket', LANG_CONST.chat_ticket)}
      </div>
    );
  };

  render() {
    const { charges, charge, user } = model.state;
    const { loading, ...createState } = model.getApiState('charges');

    charge.id = 'default';

    return (
      <div className={'mc-main-content mc-flex-col'}>
        <form
          className={'mc-setting-consultation mc-grow'}
          onSubmit={this.saveCharges}
          style={{ overflow: 'auto' }}
        >
          <div className={'mc-header'}>
            <div className={'mc-title'}>
              {lang.t(permissions.PAGES.SETTINGS_CHARGES_PAGE.title(user))}
            </div>
            {permissions.ACTIONS.SETTING_CHARGE_ADD_BUTTON.isActive && (
              <MCButton
                primary
                light
                medium
                radius
                iconname={BASE_ICONS.PLUS}
                type={'button'}
                label={LANG_CONST.buttons.add_new}
                onClick={() =>
                  popupModel.setActivePopup('add_charge', {
                    active: true,
                    component: Add
                  })
                }
              />
            )}
          </div>

          <div className={'mc-p30 mc-grow mc-flex-30-col'}>
            <div
              className={'mc-flex-20-col'}
              style={{ paddingBottom: 0, flexDirection: 'row', alignItems: 'center' }}
            >
              <div className={'mc-value-518'}>{lang.t(LANG_CONST.currency)}</div>
              <div className={''}>
                <SelectField
                  // style={{ zIndex: 2 }}
                  template={'6'}
                  isClearable={false}
                  minWidth={remCss(150)}
                  options={constants.general.currencyOptions}
                  name={'currency'}
                  // placeholder={'Specialist'}
                  value={model.input('currency') || constants.general.defaultCurrency}
                  onChange={(n, v) => model.handleChangeCurrency(v)}
                />
              </div>
            </div>
            <div
              className={'mc-flex-20-col'}
              style={{ paddingBottom: 0, flexDirection: 'row', alignItems: 'center' }}
            >
              <div className={'mc-value-518'}>{lang.t(LANG_CONST.text.follow_up_period)}</div>
              <div className={''}>
                <SelectField
                  // style={{ zIndex: 2 }}
                  template={'6'}
                  isClearable={false}
                  minWidth={remCss(150)}
                  options={followUpDurationOptions}
                  name={'followUpDuration'}
                  // placeholder={'Specialist'}
                  value={model.input('followupDuration') || 30}
                  onChange={(n, v) => model.handleChangeDuration(v)}
                />
              </div>
            </div>
            <div className={'mc-flex-20-col'}>
              {permissions.ACTIONS.SETTING_CHARGE_ADD_BUTTON.isActive && (
                <div className={'mc-value-622'}>{lang.t(LANG_CONST.def)}</div>
              )}
              {this.renderSet(charge)}
            </div>
            <div className={'mc-flex-30-col'}>
              {charges.length > 0 && (
                <div className={'mc-value-622'}>
                  {lang.t(
                    user?.isDoctor
                      ? LANG_CONST.text.other_location_charges
                      : LANG_CONST.text.per_doctor_charges
                  )}
                </div>
              )}
              {charges.map((charge) => this.renderSet(charge))}
              <div className={'mc-flex-20'}>
                {createState.error && <p className='mc-error'>{createState.errorMessage}</p>}
                <div className={'mc-grow'}></div>
                {model.state.changed && !loading && (
                  <MCButton
                    primary
                    light
                    medium
                    radius
                    type={'button'}
                    onClick={this.cancelConsultation}
                    label={LANG_CONST.buttons.cancel}
                  />
                )}
                <MCButton
                  primary
                  dark
                  radius
                  medium
                  disabled={loading}
                  type={'submit'}
                  label={LANG_CONST.buttons.save_changes}
                  loading={loading}
                />
              </div>
            </div>
            {user?.isDoctor && (
              <div className={'mc-flex-20'}>
                <div className={'mc-flex-20-col'}>
                  <MCText label={LANG_CONST.free_chat_clinic} weight={500} size={20} />
                  <MCText label={LANG_CONST.free_chat_doctor} weight={500} size={20} />
                </div>
                <div className={'mc-flex-20-col'}>
                  <ToggleSwitch
                    disabled={model.getApiState('updateFreeChatEnabled').loading}
                    onChange={() => {
                      model.handleFreeChatForDoctorAndClinic(
                        'freeForClinics',
                        !model.input('freeForClinics')
                      );
                    }}
                    checked={model.input('freeForClinics')}
                  />
                  <ToggleSwitch
                    disabled={model.getApiState('updateFreeChatEnabled').loading}
                    onChange={() => {
                      model.handleFreeChatForDoctorAndClinic(
                        'freeForDoctors',
                        !model.input('freeForDoctors')
                      );
                    }}
                    checked={model.input('freeForDoctors')}
                  />
                </div>
              </div>
            )}
          </div>
        </form>
      </div>
    );
  }
}

export default withRouter(ConsultationCharge);
